/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Col, Container, Row, Breadcrumb, BreadcrumbItem, LinkList, LinkListItem, Spinner } from 'design-react-kit';
import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import ApiService from "../../../services/api";
import { CategoryClass } from '../../categories/models/category';
import Page404 from '../../pages/page404';
import WidgetEvent from '../../events/components/widget_event';
import { WidgetClass } from '../../pages/models/widget';
import WidgetSearch from '../../pages/components/widget_search';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import { ActaAuthContext } from "pa_kit/auth";
import { LocalSettingsContext } from "services/local_settings";
import parse from 'html-react-parser';
import { Helmet } from "react-helmet-async";


const PageEventsCategory = () => {

    let { categorySlug } = useParams();

    const settings = useContext(LocalSettingsContext);
    const auth = useContext(ActaAuthContext);

    const localSettings = settings.localSettings;
    const organization = auth.organization;

    const actagov_config = auth.organization.active_licenses?.services?.actagov;

    const eventsParentCategory = localSettings.events_parent_category === null ? 'Novità' : localSettings.events_parent_category_data.title
    const eventsParentCategorySlug = localSettings.events_parent_category === null ? 'novita' : localSettings.events_parent_category_data.slug

    const [ categoryList, setCategoryList ] = useState();
    const [ category, setCategory ] = useState();    
    const [ isLoading, setIsLoading ] = useState(true);
    const [ pageNotFound, setPageNotFound ] = useState(false);

    const [ mainSection, setMainSection ] = useState({});

    const [ widget, setWidget ] = useState();

    const [ widgetSearch, setWidgetSearch ] = useState();

    const fetchCategory = async() => {
        try {
            const category = await ApiService.getCategory(categorySlug);
            setCategory(new CategoryClass(category));
            setWidget(new WidgetClass({        
                name: "EventsCategoryRow",
                class: "events-category-row",
                category: category.id,
                show_number: 12,
                label: <span></span>      
            }));
            setWidgetSearch(new WidgetClass({
                name: "SearchSection",
                class: "search-allevents-section",
                type: "search",
                label: "Cerca eventi",
                search_in: "main_sections",
                search_id: 7
            }));
            setIsLoading(false);
        } catch (error) {
            setPageNotFound(true);            
        }       
    }

    const fetchCategoryList = async() => {
        let categoryArray = [];
        const categoryListData = await ApiService.getCategoryList();
        const categoryList = categoryListData.filter(category => category.is_event === true);
        Promise.all(categoryList.map((category) => ApiService.getLatestEventsByCategory(category.id))).then((events) => {
            events.forEach((event) => {
                if(event.length > 0) {
                    categoryArray.push(event[0].category.id);
                }
            });
            const categoryEvents = categoryList.filter(cat => categoryArray.includes(cat.id));
            setCategoryList(categoryEvents);
        });
    }

    const fetchMainSections = async() => {
        const mainSectionsData = await ApiService.getMainSections();
        const mainSection = mainSectionsData.filter(main_section => main_section.id === 7); //Eventi
        setMainSection(mainSection[0]);
    }

    useEffect(() => {
        fetchCategory();
        fetchCategoryList();
        fetchMainSections();
    }, []);
       
    if(pageNotFound) return <Page404 />;
    if(isLoading) return <Container style={{ padding: "50px" }}><Spinner active /></Container>; 
    return <>
        <Helmet>
            <title>{category.name + ' | ' + organization.name}</title>
            <meta name="description" content={category.description.replace(/(<([^>]+)>)/gi, "")} />
        </Helmet>
        <Container fluid className="p-0 news-category-main-wrapper">
            <Container className="pt-5 px-3">
                <Row>
                    <Col>
                        <Breadcrumb>
                            <BreadcrumbItem>
                                <a href='/'>Home</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                <a href={'/' + eventsParentCategorySlug + '/'}>{eventsParentCategory}</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                <a href={eventsParentCategorySlug === 'novita' ? '/novita/eventi/' : '/eventi/'}>{mainSection.name}</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                {category.name}
                            </BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
            </Container>

            <Container className={'page-title events-category-page-title-page'}>
                <Row>
                    <Col lg="7">
                        <h1>{category.name}</h1>
                        <div className="mt-4">{parse(category.description)}</div>
                        <WidgetSearch widget={widgetSearch} />
                    </Col>
                    <Col lg="5">
                    <Container fluid className={'events-page-menu page-menu-content ms-lg-5 ps-lg-5'}>
                        <p className="menu-name mb-2">{mainSection.name}</p>
                        <LinkList>
                            {categoryList && categoryList.map((category) => 
                                <LinkListItem key={"key_menuItem_" + category.name} href={actagov_config?.frontend_url + (eventsParentCategorySlug === 'novita' ? 'novita/eventi/' + category.slug + '/' : 'eventi/' + category.slug + '/')} className="ps-0 menu-item-link">{category.name}</LinkListItem>
                            )}
                        </LinkList>
                    </Container>
                    </Col>
                </Row>
            </Container>

            <Container className="mt-5">
                <WidgetEvent widget={widget} />
            </Container>

            <Container fluid className={'rating-wrapper page-rating events-category-page-rating'}>
                <WidgetPageRating page_title={category.name} />
            </Container>

            <Container fluid className={'contacts-wrapper events-category-page-contacts'}>
                <WidgetContacts />
            </Container>
        </Container>
    </>;
}

export default PageEventsCategory;